//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { channelTypes } from '@motionelements/core/src/helpers/channelTypes';

function handleSeoRedirect(targetUrl, route, redirect) {
  if (!targetUrl) {
    return;
  }

  const url = new URL(targetUrl);
  if (url.pathname !== route.path) {
    // Replace path and keep the existing query string.
    const redirectFullPath = route.fullPath.replace(route.path, url.pathname);
    redirect(301, redirectFullPath);
  }
}

export default {
  name: 'channel',
  layout: 'empty',
  components: {
    ChannelPage: () => import('@/components/channels/ChannelPage.vue'),
    ProductPage: () => import('@/components/ProductPage.vue'),
  },
  async asyncData({ params, store }) {
    const channel = channelTypes.find(({ link }) => link.includes(params.channel));
    if (channel) {
      const channelId = channel.id;
      store.commit('product/setProductId', null);
      store.dispatch('channels/setChannelType', channelId);
      return { channelId };
    }
    if (!channel) {
      const match = params.channel.match(/^(.*?)-(\d+)-(.+)$/);
      if (!match) return null;
      const [, type, id, slug] = match;
      console.log(type, id, slug);
      if (id) {
        store.commit('product/setProductId', id);
      }
    }
    return {};
  },
  data() {
    return {
      channelId: null,
    };
  },
  computed: {
    ...mapState({
      productId: state => state.product.id,
    }),
  },
  async fetch({
    store, route, error, redirect,
  }) {
    const productId = store.state.product.id;
    if (productId) {
      try {
        await store.dispatch('product/fetchProductSchema');
      } catch (err) {
        console.error(err);
      }
      try {
        await store.dispatch('product/fetchProduct', { id: productId }); // public info to render the product page fast

        if (!store.state.product.current) {
          error({ statusCode: 404 });
          return;
        }

        handleSeoRedirect(store.state.product.current.url, route, redirect);
      } catch (err) {
        error({ statusCode: err?.response?.status || 500 });
      }
    }
  },
};
